import { apiSlice } from '../../api/apiSlice';
import { SimUsagesResponse } from './simUsagesApiSliceTypes';
import { DashboardParams } from '../dashboardTypes';
import { serializeQueryParams } from '../index';

const dashboardSimUsagesApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSimUsages: builder.query<SimUsagesResponse, DashboardParams>({
            query: (params) => ({
                url: `/dashboard/sim-usages?${serializeQueryParams(params)}`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetSimUsagesQuery, useLazyGetSimUsagesQuery } =
    dashboardSimUsagesApiSlice;
